export const typeList = [
    { value: 'SERVICE', label: 'Serviço' },
    { value: 'CRONTAB', label: 'Agendamento via crontab' },
    { value: 'DEVICES', label: 'Câmeras (dispositivos)' },
    { value: 'THIRDSYSTEM', label: 'Câmeras via sistema de terceiros' },
    { value: 'SENTRYAPI', label: 'Consome a api do Sentry' },
    { value: 'OTHER', label: 'Outro' }
]